export default "__VITE_ASSET__A31QZMSL__"